// NOTES
// loan statuses:
//    1. null (no UID, quote not selected,
//    2. active (assigned UID, after quote was selected)
//    3. processing (Admin has to manually move to processing)
//    4. agreed to fund (Admin has to manually move to processing)
//    5. funded (Admin has to manually move to processing))

async function updateAdminLoan(
  user,
  adminLoan,
  updatedAdminLoanData,
  keyToUpdate
) {
  // all the query params need to be provided
  // for security reasons to compare those value on backend

  const targetUrl = `${process.env.CMS_URL}/admin-loans/${adminLoan.id}`;

  // dataTranslation
  const token = await user.getIdToken();
  const res = await fetch(targetUrl, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    // body: JSON.stringify({ AdminLoanData: updatedAdminLoanData }),
    body: JSON.stringify({ [keyToUpdate]: updatedAdminLoanData }),
  });

  const respJSON = await res.json();

  return respJSON;
}

export default updateAdminLoan;
